import { useEffect, useState } from "react";

import { getInsights } from "@/api/endpoints/insights";
import InsightBadge from "@/containers/InsightBadge";
import InsightText from "@/containers/InsightText";
import useSearchParams from "@/hooks/useSearchParams";
import { Insight } from "@/types/Insight";
import { cx, pack } from "@/utils";

import styles from "./InsightHeader.module.css";

type InsightHeaderProps = { className?: string };

const InsightHeader: React.FunctionComponent<InsightHeaderProps> = ({
  className,
}) => {
  const [{ m_insight_ids, m_searches }] = useSearchParams<{
    m_insight_ids: number[];
    m_searches: string;
  }>();
  const [insights, setInsights] = useState<Insight[]>([]);

  useEffect(() => {
    if (m_searches && m_insight_ids) {
      getInsights(m_searches, pack(m_insight_ids))
        .then(({ data, ok }) => {
          if (ok && data) setInsights(data);
        })
        .catch(() => {
          // do nothing.
        });
    }
    return () => {
      // clear when modal is closed
      setInsights([]);
    };
  }, [m_searches, m_insight_ids]);

  // Don't show anything before we have a reasult, it would just look
  if (insights.length < 1) return null;

  return (
    <div className={cx(styles.root, className)}>
      {insights.map((insight, i) => {
        return (
          <div className={styles.insightText} key={i}>
            <InsightBadge
              type={insight.type}
              size="md"
              className={styles.insightBadge}
            />
            <InsightText insight={insight} />
          </div>
        );
      })}
    </div>
  );
};

export default InsightHeader;
